<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("summaryDailyStatement.Fields.title", [
            (currentItem ? currentItem.shop_name : '') + $consts.shopName(),
            currentItem ? $datetimeUtils.formatDate(currentItem.statement_date) : ''
        ]) }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-data-table
          :headers="headers"
          :items="detailItems"
          multi-sort
          class="elevation-1 px-4 pt-2"
          disable-pagination
          hide-default-footer
          fixed-header
        >
          <template v-slot:item.bill_type="{ item }">
            {{ item.bill_type | billTypesText }}
          </template>
          <template v-slot:item.material="{ item }">
            {{ item.Description }}
          </template>
          <template v-slot:item.stock="{ item }">
            <span>
              {{ item.stock_name ? item.stock_name : $t("summaryMonthlyStatementDetail.refund") }}
            </span>
          </template>
          <template v-slot:item.finally_sale_total_fee="{ item }">
            {{ $t("Global.money") }}{{ item.finally_sale_total_fee | formatMoney }}
          </template>
          <template v-slot:item.finally_return_total_fee="{ item }">
            {{ $t("Global.money") }}{{ item.finally_return_total_fee | formatMoney }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import {mapState} from "vuex";
import i18n from "@/i18n";
import SummaryMonthlyStatement from "@/api/summary_monthly_statement";

export default {
  name: "DetailDialog",

  props: {
    value: Boolean,
    currentItem: Object
  },
  computed: {
    headers: () => [
      {
        text: i18n.t("summaryDailyStatement.BillFields.bill_code"),
        align: "start",
        sortable: false,
        value: "bill_code",
      },
      {
        text: i18n.t("summaryDailyStatement.BillFields.bill_type"),
        align: "start",
        sortable: false,
        value: "bill_type",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.material"),
        align: "start",
        sortable: false,
        value: "material",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.category_name"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.stock"),
        align: "start",
        sortable: false,
        value: "stock",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.finally_sale_num"),
        align: "end",
        sortable: false,
        value: "finally_sale_num",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.finally_sale_total_fee"),
        align: "end",
        sortable: false,
        value: "finally_sale_total_fee",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.finally_return_num"),
        align: "end",
        sortable: false,
        value: "finally_return_num",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.finally_return_total_fee"),
        align: "end",
        sortable: false,
        value: "finally_return_total_fee",
      },
    ],
    detailItems() {
      return this.details.map((detail) => {
        const Description = i18n.t("Material.materialNameWithCodeAndStandard",
            [
              detail.material_code,
              detail.material_name,
              detail.unit
            ]
        );
        return Object.assign({}, detail, { Description });
      })
    },
    ...mapState(["loading"]),
  },
  data: () => ({
    dialog: false,
    details: [],
  }),
  methods: {

  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog && this.currentItem) {
          // 获取明细
          SummaryMonthlyStatement.dailyStatementBillView({
            shop_id: this.currentItem.shop_id,
            statement_date: this.currentItem.statement_date,
            stock_ids: [this.currentItem.stock_id],
          }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.details = response.data.statement_bill_details
                }
              }.bind(this)
          );
        }else {
          this.details = []
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>